export default "__VITE_ASSET__Dn54mv2t__"